import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class ServiceSelectCtrl implements IController {

  form: any;
  selectedId: string;
  options: any[];
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  from: any
  to: any
  agentIds: string[];
  group: string;
  ngPlaceholder: string;

  onChange: Function;


  private servicesRef: any;
  public selectedService: any;
  public selectedText: any;

  constructor(private $mdPanel, private $delivery) {
    this.servicesRef = this.$delivery();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const fromRef = this.from;
    const toRef = this.to;
    const agentIdsRef = this.agentIds;
    const groupRef = this.group;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'service';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMapRef = {
          from: fromRef,
          to: toRef,
          agentIds: agentIdsRef,
          group: groupRef
        }
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }


        if (!selectedId) {
          this.onChange({service: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const service = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({service: service, id: selectedId});
            panel.destroy();
          } else {
            this.servicesRef.$asyncValues([selectedId])
              .then((services) => {
                this.onChange({service: services[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({service: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedService = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.servicesRef.$asyncValues([this.selectedId])
          .then((services) => {
            this.selectedService = _.orderBy(services, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedService = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedService, 'id', '');
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      from: '<?',
      to: '<?',
      group: '<?',
      agentIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./service-select.html').default,
    controller: ServiceSelectCtrl
  });

